import { render } from "./ShoppableDropzone.vue?vue&type=template&id=7bb3ac89"
import script from "./ShoppableDropzone.vue?vue&type=script&lang=js"
export * from "./ShoppableDropzone.vue?vue&type=script&lang=js"

import "./ShoppableDropzone.vue?vue&type=style&index=0&id=7bb3ac89&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__